import * as React from 'react';
import { connect } from "react-redux"
import { Dialog, DialogContent, DialogTitle, Grid, IconButton } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { useState } from "react";
import { ChangeEvent } from "react";
import { Defaults } from "../../defaults/Defaults";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from '../controls/SubmitButton';
import { initialUsuario } from "../../redux/reducers/usuarioReducer";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import Paper from "@material-ui/core/Paper";
import InputText from "./InputText";
import InputSelect from "./InputSelect";
import { Sucursal } from "../../entities/catalogos/Sucursal";
import { ApplicationState } from "../../redux/reducers";
import AutocompleteControl, { IAutocomplete } from "../controls/AutocompleteControl";
import TextField from "@material-ui/core/TextField";
import useUsuarioApi from "../../api/usuarioApi";
import useCommonApi from '../../api/useCommonApi';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import { enums } from '../../enums/enums';
import { setUsuario } from '../../redux/actions/usuarioActions';
import swal from 'sweetalert2';
import LoadingDialog from '../controls/LoadingDialog';
import CloseIcon from '@material-ui/icons/Close';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



interface OwnProps {
    abierto: boolean
    confirmar: (usuario) => void
    cerrar: () => void
}

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    sucursales: Sucursal[]
}

interface DispatchProps {
    setUsuario: typeof setUsuario

    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
}


type Props = OwnProps & StateProps & DispatchProps;


const RegistroUsuario = ({ abierto, cerrar, confirmar, sucursales, setUsuario, solicitud, setSolicitud, setSolicitudCopia }: Props) => {
    const [usuario, setUsuarioNuevo] = useState<IUsuario>(initialUsuario);
    const [estado, setEstado] = useState("");
    const [colonia, setColonia] = useState("");
    const [codigoPostal, setCodigoPostal] = useState<IAutocomplete | null>({
        id: "",
        nombre: "",
        descripcion: "",
        parentId: ""
    });
    const [showLoading, setShowLoading] = useState(false);
    const apiSource = useCommonApi();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setUsuarioNuevo({ ...usuario, [name]: value });
    };

    const handleCodigoPostal = async (event, optionSelected) => {
        setCodigoPostal(optionSelected);
        handleChange(event);

        if (optionSelected) {
            const copiaUsuario: IUsuario = {
                ...usuario,
                codigoPostal: optionSelected.codigoPostal,
                estado: optionSelected.estado.id,
                ciudad: optionSelected.ciudad.id,
                colonia: optionSelected.id
            };

            setEstado(optionSelected.estado.nombre);
            setColonia(optionSelected.nombreColonia);
            setUsuarioNuevo(copiaUsuario);
        }
    };

    const guardarUsuario = () => {

        setShowLoading(true);
        callApiUsuario().then(res => {
            // setUsuario({ ...usuario });
            setShowLoading(false);
            swal.fire({
                titleText: traducirMessage(14), // '¡Exitoso!',
                text: traducirMessage(64), // "El usuario fue guardado exitosamente.",
                type: 'success',
            });

            confirmar(usuario);
        }).catch(err => {
            //   setUsuario({ ...usuario });
            setShowLoading(false);
            swal.fire({
                titleText: traducirMessage(14), // '¡Exitoso!',
                text: traducirMessage(64), // "El usuario fue guardado exitosamente.",
                type: 'success',
            });


            confirmar(usuario);
        });

    };

    const setUsuarioDato = (): IUsuario => {
        return {
            id: 0,
            usuario: usuario.nombre,
            password: usuario.password,
            email: usuario.email,
            telefono: usuario.telefono,
            nombre: usuario.nombre,
            apellido: usuario.apellido,
            tipoPersonaId: usuario.tipoPersonaId,
            rfcEmpresa: usuario.rfcEmpresa,
            razonSocial: usuario.razonSocial,
            pais: usuario.pais,
            codigoPostal: usuario.codigoPostal,
            estado: usuario.estado,
            colonia: usuario.colonia,
            calle: usuario.calle,
            numeroExterior: usuario.numeroExterior,
            numeroInterior: usuario.numeroInterior,
            giroEmpresa: usuario.giroEmpresa,
            formaPago: usuario.formaPago
        };
    };


    const callApiUsuario = async () => {
        const result = await apiSource.postAsync<any>("/usuario", setUsuarioDato());
        return result;
    };

    return (<>

        <Dialog open={abierto} maxWidth={"lg"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title">
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                        {/* Registro Usuario */
                            traducirLabel(261)}
                    </Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>


            </DialogTitle>
            <DialogContent dividers>
                <ValidatorForm onSubmit={guardarUsuario}>
                    <Box mb={1} className="title-2">
                        {/* Datos de Contacto */
                            traducirLabel(70)}
                    </Box>

                    <Grid container spacing={3}>
                        <InputText label={traducirLabel(310)} value={usuario.usuario} name="usuario" onChange={handleChange} />

                        <InputText label={traducirLabel(53)} value={usuario.password} name="password"
                            onChange={handleChange} />

                        <InputText label={traducirLabel(110)} value={usuario.email} name="email"
                            onChange={handleChange} isEmail={true} />

                        <InputText label={traducirLabel(290)} value={usuario.telefono} name="telefono"
                            onChange={handleChange} />

                        <InputText label={traducirLabel(207)} value={usuario.nombre} name="nombre" onChange={handleChange} />

                        <InputText label={traducirLabel(18)} value={usuario.apellido} name="apellido"
                            onChange={handleChange} />
                    </Grid>

                    <Box mt={4} mb={1} className="title-2">
                        {/* Datos Fiscales */
                            traducirLabel(74)}
                    </Box>

                    <Grid container spacing={3}>

                        <InputSelect label={traducirLabel(301)} name="tipoPersona" value={usuario.tipoPersona}

                            source="tipo-persona/many" onChange={handleChange} />



                        <InputText label={traducirLabel(253)} value={usuario.razonSocial} name="razonSocial"

                            onChange={handleChange} />
                    </Grid>

                    <Box mt={4} mb={1} className="title-2">
                        {/* Domicilio Fiscal */
                            traducirLabel(104)}
                    </Box>

                    <Grid container spacing={3}>
                        <InputSelect label={traducirLabel(224)} name="pais" value={usuario.pais}
                            source="pais/many" onChange={handleChange} />

                        <Grid item xs={12} sm={6} md={4}>
                            <AutocompleteControl name="codigoPostal"
                                source="colonia/by-text-and-country"
                                label={traducirLabel(41)}
                                value={codigoPostal}
                                onChange={handleCodigoPostal}
                                filter={{ paisId: usuario.pais }} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField label={traducirLabel(123)} value={estado} variant="filled" fullWidth
                                InputProps={{ readOnly: true, }} />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField label={traducirLabel(42)} value={colonia} variant="filled" fullWidth
                                InputProps={{ readOnly: true, }} />
                        </Grid>

                        <InputText label={traducirLabel(24)} value={usuario.calle} name="calle" onChange={handleChange} />

                        <Grid item xs={6} sm={3} md={2}>
                            <TextValidator
                                label={traducirLabel(196)}
                                value={usuario.numeroExterior}
                                name="numeroExterior"
                                onChange={handleChange}
                                variant="filled"
                                fullWidth
                                validators={['required', 'minNumber:0']}
                                errorMessages={[traducirLabel(126)]}
                            />
                        </Grid>

                        <Grid item xs={6} sm={3} md={2}>
                            <TextValidator
                                label={traducirLabel(198)}
                                value={usuario.numeroInterior}
                                name="numeroInterior"
                                onChange={handleChange}
                                variant="filled"
                                fullWidth
                            />
                        </Grid>
                    </Grid>

                    <Box mt={4} mb={1} className="title-2">
                        {/* Datos Adicionales */
                            traducirLabel(66)}
                    </Box>

                    <Grid container spacing={3}>
                        <InputSelect label={traducirLabel(150)} name="giroEmpresa" value={usuario.giroEmpresa}
                            source="tipo-giro/many" onChange={handleChange} />

                        <InputSelect label={traducirLabel(299)} name="formaPago" value={usuario.formaPago}
                            source="tipo-pago/many" onChange={handleChange} />

                        <InputSelect label={traducirLabel(289)} name="sucursalCercana" value={usuario.sucursalCercana}
                            dataSource={sucursales} onChange={handleChange} />
                    </Grid>

                    <SubmitButton label={traducirButton(12)} />
                </ValidatorForm>

            </DialogContent>

        </Dialog>





        {
            showLoading &&
            <> <LoadingDialog titulo="Procesando" abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    sucursales: state.sucursales,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario
});


const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setUsuario: setUsuario
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistroUsuario);
